import { PolicyGetResponse, PolicyTermSearchResponse } from '@lio/api-types';
import { useSearchBillingPlan } from '@services/policy';
import { EndorsementPolicyDialogType, PolicyTransaction } from '@models/policyTransaction';
import { CreatePolicyTransactionDialog } from './CreatePolicyTransactionDialog';

interface UpdateBillPlanDialogProps {
  isOpen: boolean;
  policy: PolicyGetResponse;
  handleHide: () => void;
  selectedPolicyTransaction?: PolicyTransaction;
  policyTransactions: PolicyTransaction[];
  policyTerms: PolicyTermSearchResponse['items'];
}

// When connected to backend, make sure date is formatted via setDateToMidnight() (utils)
export const UpdateBillPlanDialog = ({
  selectedPolicyTransaction,
  isOpen,
  handleHide,
  policy,
  policyTransactions,
  policyTerms,
}: UpdateBillPlanDialogProps) => {
  const { billingPlans, isLoading } = useSearchBillingPlan({ policyTermType: policy.billingPlan?.policyTermType });

  const billingPlanOptions = billingPlans?.items.map((bp) => {
    return { ...bp, value: bp.id };
  });

  if (isLoading) {
    return null;
  }

  return (
    <CreatePolicyTransactionDialog
      isOpen={isOpen}
      policyTransactions={policyTransactions}
      policyTerms={policyTerms}
      policy={policy}
      isDialogLoading={isLoading}
      selectedPolicyTransaction={selectedPolicyTransaction}
      onCancel={handleHide}
      dialogType={EndorsementPolicyDialogType.UpdateBillPlan}
      other={{ billingPlanOptions, overrideCreateButtonText: 'Process Endorsement' }}
    />
  );
};
